import React, { useCallback, useState, useEffect } from 'react';
import { useIntl } from "react-intl";
import './styles.scss';

const SELECT_ALL = 'multiselect-select-all-items';

const Multiselect = ({ 
  options = [],
  onChange,
  selectAll = false
}) => {
  const [showBox, setShowBox] = useState(false);
  const [filterBoxes, setFilterBoxes] = useState('');
  const [selected, setSelected] = useState([]);
  const [boxes, setBoxes] = useState(options);
  const { formatMessage } = useIntl();

  useEffect(() => {
    const filteredSelectedOptions = selected.filter(option => 
      option.value !== SELECT_ALL
    );

    onChange(filteredSelectedOptions);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selected])

  useEffect(() => {
    if (selectAll && options.length > 0) {
      if (options[0].value === SELECT_ALL && formatMessage !== options[0].label) {
        options.shift();
        options.unshift({ value: SELECT_ALL, label: formatMessage({ id: 'todos-usuarios' }) });
        setBoxes(options.map(option => option))
      } else {
        options.unshift({ value: SELECT_ALL, label: formatMessage({ id: 'todos-usuarios' }) });
        setBoxes(options.map(option => option))
      }

      setSelected(options.map(option => option))
    }
  }, [options, selectAll, formatMessage])

  useEffect(() => {
    const sanitizedSearch = filterBoxes.replace(/([[\]()+{}?])/, '\\$1');
    const search = new RegExp(sanitizedSearch, 'i')

    setBoxes(options.filter(item => search.test(item.label)));
  }, [filterBoxes, options])

  const handleSelected = useCallback(option => {
    const exists = selected.find(opt => option.value === opt.value);
    
    if (option.value !== SELECT_ALL) {
      if (exists) {
        setSelected(selected.filter(opt => option.value !== opt.value && opt.value !== SELECT_ALL));
      } else {
        setSelected(oldSelected => {
          const newSelected = [...oldSelected, option];

          if (newSelected.length === options.length - 1 && selectAll) {
            return [...newSelected, options[0]];
          }

          return [...newSelected];
        })
      }
    } else {
      const isAllSelected = selected.find(opt => opt.value === SELECT_ALL);

      if (isAllSelected)
        setSelected([]);
      else
        setSelected(options.map(option => option))
    }
  }, [selected, options, selectAll]);

  return (
    <div className="multiselect-component">
      <div className="selectbox" onClick={() => setShowBox(!showBox)}>
        <select>
          <option>{formatMessage({ id: 'selecione-um-ou-mais' })}</option>
        </select>
        <div className="over-select"></div>
      </div>
      <div className={`${showBox ? 'display-multi-checkboxes' : 'hide-multi-checkboxes'}`}>
        <div className="search-input-select">
          <input 
            type="text" 
            placeholder={formatMessage({ id: 'procure-por-nome' })}
            onChange={(e) => setFilterBoxes(e.target.value)} 
          />
        </div>
        
        {boxes.map((option, _index) => (
          <label 
            key={_index} 
            htmlFor={option.value} 
            onClick={(e) => {
              e.preventDefault();
              handleSelected(option)
            }}
          >
            <input 
              type="checkbox" 
              checked={selected.includes(option)} 
              id={option.value}
              readOnly
            /> 

            {option.label}
          </label>
        ))}
      </div>
    </div>
  )
}

export default Multiselect;